(() => {
  let elements = document.querySelectorAll(".product-grid-item-select");
  elements.forEach((selectElement) => {
    // Preload the images, might impact page speed
    Array.from(selectElement.options).forEach(function (element) {
      var img = new Image();
      img.src = element.dataset.image;
    });

    // Event when the drop down is selected
    selectElement.addEventListener("change", (event) => {
      let imageSrc = event.target.options[event.target.selectedIndex].dataset.image
      let productGridItem = event.target.closest(".product-grid-item")
      let backgroundSizeCover = productGridItem.querySelector(".background-size-cover")
      backgroundSizeCover.style.backgroundImage = 'url(' + imageSrc + ')'
    })
  })
})()